import { useNavigate } from "react-router-dom";

function ChooseService() {

  const navigate = useNavigate();

  const selectService = (service) => {

    localStorage.setItem(

      "service",

      service

    );

    navigate("/home");

  };

  return (

    <div>

      <h1>

        Choose Service

      </h1>

      <button onClick={() => selectService("chef")}>

        Home Chef

      </button>

      <button onClick={() => selectService("restaurant")}>

        Restaurant

      </button>

      <button onClick={() => selectService("hotel")}>

        Hotel

      </button>

      <button onClick={() => selectService("bakery")}>

        Bakery

      </button>

      <button onClick={() => selectService("catering")}>

        Catering

      </button>

    </div>

  );

}

export default ChooseService;